import { render, staticRenderFns } from "./CampusUserNetworks.vue?vue&type=template&id=0c27b578&scoped=true&"
import script from "./CampusUserNetworks.vue?vue&type=script&lang=ts&"
export * from "./CampusUserNetworks.vue?vue&type=script&lang=ts&"
import style0 from "./CampusUserNetworks.vue?vue&type=style&index=0&id=0c27b578&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27b578",
  null
  
)

export default component.exports